import { FC, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import {
  fetchDefaultFilters,
  setIsDetectedLocation,
} from "../../store/modules/dashboard";
import { checkLocationPermission, getLocation } from "../../utils/permissions";

interface DetectLocationProps {
  children: JSX.Element;
  setIsDetectedLocation: (hasAccess: boolean) => void;
  fetchDefaultFilters: (postalCode: string) => void;
}

const DetectLocation: FC<DetectLocationProps> = (props) => {
  const { children, setIsDetectedLocation, fetchDefaultFilters } = props;

  const isInitializedRef = useRef(false);

  useEffect(() => {
    if (!isInitializedRef.current) {
      isInitializedRef.current = true;
      checkLocationPermission().then((result) => {
        if (result === "denied" || result === "prompt") {
          setIsDetectedLocation(true);
        }
        if (result === "granted" || result === "prompt") {
          getLocation()
            .then((postalCode) => {
              fetchDefaultFilters(postalCode);
            })
            .catch((error) => {
              setIsDetectedLocation(true);
            });
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return children;
};

const mapStateToProps = (state: RootState) => ({});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  setIsDetectedLocation: (hasAccess: boolean) =>
    dispatch(setIsDetectedLocation(hasAccess)),
  fetchDefaultFilters: (postalCode: string) =>
    dispatch(fetchDefaultFilters(postalCode)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DetectLocation);
